import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type celfCredType = CarrierLogisticsCredType
export const celfDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const celf: CarrierDef<celfCredType> = {
  name: 'Celestial Freight',
  scac: 'celf',
  ...carrierLogistics,
  engineLayers: ['documents', 'pickup', 'profinder', 'rating', 'tracking'],
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  documentTypes: celfDocumentTypes,
}
